import React from 'react';
import type { SessionScreen } from '../../../features/flow/session';
import { cleanTitle, getIllustrationSrc } from '../../../features/flow/utils';

export function SubmissionStatusScreenBody({
  sessionScreen,
}: {
  sessionScreen: SessionScreen;
}) {
  const heading = Array.isArray(sessionScreen.headings) && sessionScreen.headings.length > 0 ? sessionScreen.headings[0] : '';
  const title = cleanTitle(sessionScreen.title ?? '');
  const subtitle = (sessionScreen.subtitle ?? '').trim();
  const paragraphs = Array.isArray(sessionScreen.paragraphs) ? sessionScreen.paragraphs.filter((p) => String(p).trim() !== '') : [];

  return (
    <div className="w-full flex flex-col items-center text-center gap-14">

      {heading ? <div className="text-7xl w-[72px] h-[72px] md:text-8xl md:w-[96px] md:h-[96px] lg:text-9xl lg:w-[128px] lg:h-[128px] leading-none">{heading}</div> : null}

      <div className="flex flex-col gap-6 items-center">

        <h1 className="text-lg md:text-[22px] lg:text-2xl font-medium md:font-semibold text-[#131315]">{title}</h1>

        {subtitle ? (
          <p className="text-[#525353] text-base w-full max-w-[520px] font-medium">{subtitle}</p>
        ) : null}

        {paragraphs.length > 0 ? (
          <div className="w-full max-w-[416px] flex flex-col items-center gap-5">
            {paragraphs.map((p) => (
              <p key={p} className="text-[#525353] text-sm md:text-base font-medium leading-6">
                {p}
              </p>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}

